import instance from '@apis/instance';
import {
    GiftRecommendedItemResponse,
    MainRecommendedItemResponse,
    ShopRecommendedItemResponse,
} from '@models/item/recommendedItem';

class RecommendedItemApi {
    static getMainRecommendedItems(): Promise<MainRecommendedItemResponse> {
        return instance.get('/recommended-item/main');
    }

    static getGiftRecommendedItems(type: 'PRODUCT' | 'CASH'): Promise<GiftRecommendedItemResponse> {
        return instance.get('/recommended-item/gift', { params: { type } });
    }

    static getShopRecommendedItems(shopId: string): Promise<ShopRecommendedItemResponse> {
        return instance.get(`/recommended-item/shop/${shopId}`);
    }
}

export default RecommendedItemApi;
